// Shared helpers for BookUploadForm and tests

export const isSeriesNumberValid = (value: string): boolean =>
  /^(\d+(\.\d+)?)?$/.test(value)

export const isFileSizeWithinLimit = (bytes: number, maxMb = 30): boolean =>
  bytes / 1024 / 1024 < maxMb
